import SliderManager from 'assets/core/js/module/sliderManager'
import type { SwiperOptions } from 'swiper/types'

export default function (): void {
  document.querySelectorAll('.cms__slider').forEach((el) => {
    const id = el.id

    const config: SwiperOptions = {
      slidesPerView: 'auto',
      spaceBetween: 16,
      navigation: {
        nextEl: `#${id}-next`,
        prevEl: `#${id}-prev`,
      },
      pagination: {
        el: `#${id}-pagination`,
      },
      loop: false,
    }

    SliderManager.initSlider(`#${id}`, config)
  })
}
